import { localStorageInstance } from '@gem/modules/storage';

const CURRENT_VIEW_CALENDAR_KEY = 'currentViewCalendar';

export function setCalendarCurrentView(view: string): void {
  localStorageInstance.setItem(CURRENT_VIEW_CALENDAR_KEY, view);
}

export function getCalendarCurrentView(): string | null {
  return localStorageInstance.getItem(CURRENT_VIEW_CALENDAR_KEY);
}
